import { render, staticRenderFns } from "./userCenterPage.vue?vue&type=template&id=eab5ce32&scoped=true&"
import script from "./userCenterPage.vue?vue&type=script&lang=js&"
export * from "./userCenterPage.vue?vue&type=script&lang=js&"
import style0 from "./userCenterPage.vue?vue&type=style&index=0&id=eab5ce32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab5ce32",
  null
  
)

export default component.exports